import {ImageUploader} from "../../../../components/ImageUploader";
import {CustomDialog} from "../../../../components/DialogCustom";
import React, {useState} from "react";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

export const CategoryCoverImageDialog = ({
  initialCategory,
  onSaveChangeCoverImage
}) => {
  const [imageUrl, setImageUrl] = useState<string>(initialCategory?.coverImageUrl || '')

  const handleUploadedImage = (url: string) => setImageUrl(url)
  const handleSubmit = () => onSaveChangeCoverImage(imageUrl);
  return (
    <CustomDialog>
      <ImageUploader
        isSquareCropper
        cropEnabled={false}
        handleUploadedImage={handleUploadedImage}
        placeholder={"未上傳圖片"}
        uploadFolder="categoryCover"
        uploadedImageUrl={imageUrl}
      />
      <div className="flex justify-end space-x-4">
        <ActionButton
          label="確定"
          disabled={!imageUrl}
          onClick={handleSubmit}
        />
      </div>
    </CustomDialog>
  )
}
